exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-27B-z {\n  width: 100%;\n  margin: 0 0 0.5rem;\n}\n.container-27B-z .button-3yQ5G {\n  padding: 0.5rem 2rem;\n  height: 40px;\n}\n.fullWidth-2XGqT {\n  display: flex;\n  align-items: flex-end;\n}\n.fullWidth-2XGqT .button-3yQ5G {\n  margin-left: 1rem;\n}\n.stacked-2rKyR {\n  display: block;\n}\n.stacked-2rKyR .button-3yQ5G {\n  display: block;\n  margin: 1rem 0 2rem;\n}\n.input-n89tt input[type=text] {\n  box-sizing: content-box;\n  padding: 0.5rem 1rem;\n  border: none;\n}", ""]);

// Exports
exports.locals = {
	"container": "container-27B-z",
	"button": "button-3yQ5G",
	"fullWidth": "fullWidth-2XGqT",
	"stacked": "stacked-2rKyR",
	"input": "input-n89tt"
};